import { apiAccess } from 'components/developer-settings';

/** @ngInject */
export default function apiAccessRouter($stateProvider) {
    const apiAccessState = {
        url: '/developer-settings',
        views: {
            contentBody: {
                component: apiAccess.Component.selector
            }
        }
    };

    $stateProvider
        .state('main.developer-settings.api-access', apiAccessState);
}



// WEBPACK FOOTER //
// ./app/components/developer-settings/api-access/api-access.router.js